module.exports = __webpack_public_path__ + "img/Loesung_fuer_Bestattungsinstitute.62a91506.png";